define('gumbo-js-client-lib/forms/liveData/PlayerStatsForm',{
	batting: {
		atBat: null,
		assists: null,
		baseOnBalls: null,
		battingOrder: null,
		caughtStealing: null,
		doubles: null,
		flyOuts: null,
		groundOuts: null,
		hits: null,
		hitByPitch: null,
		homeruns: null,
		leftOnBase: null,
		putOuts: null,
		runs: null,
		sacBunts: null,
		sacFlys: null,
		stolenBases: null,
		strikeOuts: null,
		triples: null
	},
	pitching: {
		outs: null,
		battersFaced: null,
		errors: null,
		runs: null,
		hits: null,
		inningsPitched: null,
		strikeOuts: null,
		homeruns: null,
		baseOnBalls: null,
		pitchesThrown: null,
		strikes: null
	}
});
